var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-config-provider',{attrs:{"locale":_vm.locale}},[_c('div',{class:_vm.menuHidden?'menue-left-hidden':'menue-left-open',attrs:{"id":"app"}},[_c('keep-alive',[_c('router-view')],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }